import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import { FloatyImage } from "../../FloatyImage/FloatyImage";
import { Container } from "../../Container/Container/Container";
import { Background, backgroundBgColors } from "../../Background/Background";
import { Tout } from "../../Tout/Tout/Tout";
import { VerticalSpacer } from "../../VerticalSpacer/VerticalSpacer";
import styles from "./ToutSlice.module.scss";
import classnames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var toutSliceBackgroundColors = _toConsumableArray(backgroundBgColors);
export var toutSliceMarginVariants = ['noMargin', 'normalMargin'];
export var ToutSlice = function ToutSlice(_ref) {
  var background = _ref.background,
    _ref$floatyImage = _ref.floatyImage,
    floatyImage = _ref$floatyImage === void 0 ? {} : _ref$floatyImage,
    tout = _ref.tout,
    _ref$mobileBackground = _ref.mobileBackgroundPaddingLarge,
    mobileBackgroundPaddingLarge = _ref$mobileBackground === void 0 ? false : _ref$mobileBackground,
    marginVariant = _ref.marginVariant,
    verticalSpacer = _ref.verticalSpacer;
  return /*#__PURE__*/_jsx(Background, _objectSpread(_objectSpread({}, background), {}, {
    padding: mobileBackgroundPaddingLarge ? '250px' : '210px',
    children: /*#__PURE__*/_jsx("div", {
      className: styles.boundary,
      children: /*#__PURE__*/_jsxs(VerticalSpacer, _objectSpread(_objectSpread({}, verticalSpacer), {}, {
        className: styles.spacing,
        padding: marginVariant === 'noMargin' ? 'none' : verticalSpacer === null || verticalSpacer === void 0 ? void 0 : verticalSpacer.padding,
        "data-e2e-name": "tout_slice",
        children: [/*#__PURE__*/_jsx(FloatyImage, _objectSpread({}, floatyImage)), /*#__PURE__*/_jsx(Container, {
          children: /*#__PURE__*/_jsx("div", {
            className: classnames(styles.content),
            children: /*#__PURE__*/_jsx(Tout, _objectSpread({}, tout))
          })
        })]
      }))
    })
  }));
};